import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useReviewerSummary } from '../../../hooks/analytics/useReviewerReports.ts';
import { WidgetCard } from '../controller/shared.tsx';
import { BAR_RADIUS, CHART_AXIS_LINE, CHART_AXIS_TICK, CHART_GRID_STROKE, CHART_TOOLTIP_STYLE, SEMANTIC } from '../theme.ts';

/** `reviewer_pending_by_tester` — bar of pending-review count per tester. */
export const ReviewerPendingByTesterChart: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useReviewerSummary();
  const chartData = data?.by_tester ?? [];

  return (
    <WidgetCard
      title="Pending Review by Tester"
      description="Runs awaiting review, grouped by the tester who submitted them"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load pending-by-tester breakdown.'}
      isEmpty={!isLoading && !isError && chartData.length === 0}
      emptyMessage="Nothing pending review."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} layout="vertical" margin={{ top: 10, right: 16, bottom: 10, left: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_STROKE} horizontal={false} />
            <XAxis type="number" tick={CHART_AXIS_TICK} axisLine={CHART_AXIS_LINE} tickLine={false} allowDecimals={false} />
            <YAxis
              type="category"
              dataKey="tester_name"
              tick={CHART_AXIS_TICK}
              axisLine={CHART_AXIS_LINE}
              tickLine={false}
              width={110}
            />
            <Tooltip contentStyle={CHART_TOOLTIP_STYLE} cursor={{ fill: 'rgba(148, 163, 184, 0.08)' }} />
            <Bar dataKey="pending" name="Pending" fill={SEMANTIC.warn.chart} radius={BAR_RADIUS} maxBarSize={28} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </WidgetCard>
  );
};

export default ReviewerPendingByTesterChart;
